import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { Loading } from "@/components/common/States";
import { canAccessPath } from "@/config/nav";
import AccessDenied from "@/components/common/AccessDenied";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen grid place-items-center"><Loading label="Preparing your workspace…" /></div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.must_reset_password) return <Navigate to="/force-reset" replace />;
  if (!canAccessPath(user.role, location.pathname)) return <AccessDenied />;
  return children;
}
